import gql from 'graphql-tag';

export const AnalyticsViewersQuery = gql`
	query LivePageAnalyticsViewersQuery($contentId: ID!, $accountIds: [String]) {
		singleContent(id: $contentId) {
			id
			contentAnalyticsViewsByUser(accountIds: $accountIds) {
				pageViews {
					userProfile {
						id
					}
					views
				}
			}
		}
	}
`;
